<template>
  <v-container
    class=" metric-trends-view"
    align-center
    justify-center
    fill-height
  >
    <v-layout class="pa-0 mt-3" v-if="!loading && !noData" column>
  
      <v-flex class="chart-area">
        <bar-chart
          style="height: 300px;margin-bottom: 30px;width: 100%;"
          v-if="!loading"
          :data="scoreTrendChartData"
          :options="scoreTrendChartOptions"
        ></bar-chart>
      </v-flex>
      <v-flex class="chart-area">
        <bar-chart
          style="height: 300px;width: 100%;"
          v-if="!loading"
          :data="distributionTrendChartData"
          :options="distributionTrendChartOptions"
        ></bar-chart>
      </v-flex>
    </v-layout>
    <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    <NoResult v-if="!loading && noData"></NoResult>
  </v-container>
</template>

<script>
import each from 'lodash/each'
import routes from '@/route_names'
import BarChart from '@/components/insights/BarChart.js'
import constants from '@/constants'
import insightsApi from '@/api/insights'
import NoResult from '@/components/insights/NoResult'
import filterMixins from '@/mixins/filter'
export default {
  name: 'MetricTrendsView',
  mixins:[filterMixins],
  components: {
    BarChart,
    NoResult
  },
  data() {
    return {
      loading: true,
      noData: false,
      metricType: null,
      intervals: [
        { id: 'WEEKLY', label: 'Weekly' },
        { id: 'MONTHLY', label: 'Monthly' },
        { id: 'QUARTERLY', label: 'Quarterly' }
      ],
      scoreTrendChartData: {
        labels: [],
        datasets: []
      },
      distributionTrendChartData: {
        labels: [],
        datasets: []
      },
      insights: {},
      metricQuestions: [],
      table: [],
      scoreTrendChartOptions: {
        legend: {
          position: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                color: 'rgba(0, 0, 0, 0)'
              },
              ticks: {}
            }
          ],
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: false,
                min: 0,
                max: 100
              },
              id: 'line-y-axis'
            }
          ]
        },
        tooltips: {
            callbacks: {
                label: function(item, data) {
                    console.log(item, data)
                    let base =
                      data.datasets[item.datasetIndex].label + ': <b>' + item.value + '</b>'

                    if (data.datasets[item.datasetIndex].counts)
                      base += '(' + data.datasets[item.datasetIndex].counts[item.index] + ')'
                    return base
                }
            }
        }
      },
      distributionTrendChartOptions: {
        centerText: null,
        legend: {
          position: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        gridLines: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                color: 'rgba(0, 0, 0, 0)'
              },
              ticks: {},
              barThickness: 30,
              display: false, //optional
            }
          ],
          yAxes: [
            {
              stacked: true,
              gridLines: {
                color: 'rgba(0, 0, 0, 0)'
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100
              },
              display: false, //optional
              barThickness: 30,
              categoryPercentage: 1.0,
              barPercentage: 1.0,
              id: 'bar-y-axis',
              type: 'linear',
              position: 'right'
            }
          ]
        }
      }
    }
  },
  computed: {},

  mounted() {
    if (this.$router.currentRoute.name === routes.INSIGHTS_METRICS_NPS_TRENDS) {
      this.metricType = 'nps'
      this.scoreTrendChartOptions.scales.yAxes[0].ticks.min = -100
    } else if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_CSAT_TRENDS
    ) {
      this.scoreTrendChartOptions.scales.yAxes[0].ticks.min = 0
      this.metricType = 'sat'
    } else if (
      this.$router.currentRoute.name === routes.INSIGHTS_METRICS_CES_TRENDS
    ) {
      this.scoreTrendChartOptions.scales.yAxes[0].ticks.min = 0
      this.metricType = 'es'
    }
    this.getData()
    const vm = this
    this.$store
      .dispatch('campaign/getQuestions', {
        campaignId: this.$router.currentRoute.params.campaignId,
        type: this.metricType.toUpperCase()
      })
      .then(function(data) {
        vm.metricQuestions = data.questions
      })
  },
  watch: {
    $route: function() {
      this.getData()
    }
  },
  methods: {
    getData() {
      const vm = this
      vm.loading = true
      insightsApi
        .getMetricsTrends({
          campaignId: this.$router.currentRoute.params.campaignId,
          metricType: this.metricType,
          query: {
            from: this.$router.currentRoute.query.from,
            to: this.$router.currentRoute.query.to,
            interval: this.$router.currentRoute.query.interval || 'MONTHLY',
            ...this.getAttributeFilters()
          }
        })
        .then(function(res) {
          const results = res.data.results
          if(results === 'NO_RESULT'){
            vm.noData = true
            vm.loading = false
            return
          }
          vm.insights = results
          if (results.length === 0) {
            vm.noData = true
            vm.loading = false
            return
          } else {
            vm.noData = false
          }
          const metricsTrendData = {
            label: 'Score',
            data: [],
            type: 'line',
            fill: true,
            borderWidth: 2,
            borderColor: constants.colors.theme.primaryLight2,
            backgroundColor: constants.colors.theme.accentLight1,
            yAxisID: 'line-y-axis'
          }
          const datasets = {}
          vm.scoreTrendChartData.labels = vm.distributionTrendChartData.labels = results.map(
            function(d) {
              each(d.metrics.reverse(), function(metric) {
                datasets[metric.label] = datasets[metric.label] || {
                  label: metric['label'],
                  data: [],
                  counts: [],
                  yAxisID: 'bar-y-axis'
                }
                datasets[metric.label].data.push(metric.percent)
                datasets[metric.label].counts.push(metric.count)
              })
              metricsTrendData.data.push(d.score)
              return d.label
            }
          )

          vm.scoreTrendChartData.datasets = [metricsTrendData]

          const tmpData = []
          each(datasets, function(value, key) {
            tmpData.push(value)
          })
          if (tmpData.length === 3) {
            tmpData[0].backgroundColor = constants.colors.rated5
            tmpData[1].backgroundColor = constants.colors.rated3
            tmpData[2].backgroundColor = constants.colors.rated1
          } else {
            tmpData[0].backgroundColor = constants.colors.rated5
            tmpData[1].backgroundColor = constants.colors.rated4
            tmpData[2].backgroundColor = constants.colors.rated3
            tmpData[3].backgroundColor = constants.colors.rated2
            tmpData[4].backgroundColor = constants.colors.rated1
          }
          // tmpData.unshift(metricsTrendData)
          console.log(tmpData)
          vm.distributionTrendChartData.datasets = tmpData
          // vm.buildTable(results)
          vm.loading = false
        })
    },
    buildTable: function(insights) {
      const vm = this
      const labels = insights.map(function(d, i) {
        d.label = d.driver
        return d
      })
      this.table = labels
    },
    chartJsAfterLabelCallback: function(item, data) {
      console.log(item, data)
      return (
        data.datasets[item.datasetIndex].label +
        ':' +
        item.value +
        '(' +
        data.datasets[item.datasetIndex].counts[item.index] +
        ')'
      )
    }
  }
}
</script>

<style lang="stylus">
.metric-trends-view {
    padding-top 30px
    .driver-distribution-header {
        color $color-primary-light-5
        font-size 16px
        text-align center
        margin-top 30px
    }
    .chart-area {
      display: flex
      align-items center
      }
}
</style>
